import type { ReactNode } from 'react';
import { AlertBar } from '../AlertBar';

type TableErrorDisplayProps = {
  error: Error;
  title?: ReactNode;
};

/**
 * Error display component specifically for table errors.
 * Shows a user-friendly error message with guidance.
 */
export function TableErrorDisplay({ error, title }: TableErrorDisplayProps) {
  return (
    <div className="flex flex-col gap-3">
      <AlertBar variant="danger" icon="danger" title={title ?? 'Failed to render table'}>
        <div className="flex flex-col items-center justify-center">
          <p className="text-xs">An unexpected error occurred while loading the table.</p>
          <p className="text-xs">Try refreshing the page or contact support if the issue persists.</p>
        </div>
      </AlertBar>
    </div>
  );
}
